import wallet from './components/wallet';
import {toggleClass, parseUrlParams} from './helpers';
import tokenManager from './tokenManager';

export default class platform {
    constructor(app) {
        this.name = 'web';
        this.id = 'web';
        this.app = app;
        this.settings = {
            COOKIE_NAME: 'cin_sid',
            LANDING_PAGE: 'https://1check.in',
        };
        this.events = {};
    }
    on(eventType, callback) {
        if (!this.events[eventType]) this.events[eventType] = [];
        this.events[eventType].push(callback);
    }
    off(eventType, callback) {
        this.events[eventType].splice(
            this.events[eventType].findIndex(callback), 1
        );
    }
    logout() {
        window.document.cookie =  `${this.settings.COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        try {
            // Use TokenManager to remove token
            tokenManager.removeToken();
            this.app.settings.token = '';
        } catch (err) {};
        if (window.location.pathname.match(/\w{32}\/$/)) {
            window.location.replace(window.location.pathname
                .replace(/\w{32}\/$/, ''));
        } else {
            this.app.get('login/');
        }
    }
    init() {
        if (location.search && location.search.match(/just_activated/)) {
            this.app.settings.just_activated = true;
        }

        // Check URL for token parameter
        const urlParams = parseUrlParams(window.location.href);

        if (urlParams.token) {
            console.log('platformWeb.init: Token found in URL');
            // Save token from URL to localStorage
            tokenManager.saveToken(urlParams.token);

            // Set token in app
            this.app.token = urlParams.token;
            this.app.default_headers[this.app.settings.token_header] = urlParams.token;
        } else {
            // Try to restore token from localStorage
            const savedToken = tokenManager.getToken();
            if (savedToken) {
                console.log('platformWeb.init: Token restored from localStorage');
                this.app.token = savedToken;
                this.app.default_headers[this.app.settings.token_header] = savedToken;
            }
        }

        // Check for trip_token in URL (from shared trip invite link)
        if (urlParams.trip_token) {
            try {
                window.localStorage.setItem('trip_token', urlParams.trip_token);
            } catch (err) {}
        }

        // Always call getUserData - it will handle success/error appropriately
        this.app.getUserData(() => {
            // Successful authentication - refresh timestamp
            tokenManager.refreshToken();
            this._claimTripToken();

            if (window.location.hash) {
                this.app.get(window.location.hash.replace(/^#/, ''));
            } else {
                this.app.get(this.app.start_uri);
            }
        }, (userView, status) => {
            // Authentication failed - remove invalid token and show login error
            console.log('platformWeb.init: Authentication failed');
            tokenManager.removeToken();
            this.app.token = null;
            userView.onNetworkError(status);
        });
    }
    _claimTripToken() {
        let tripToken;
        try {
            tripToken = window.localStorage.getItem('trip_token');
        } catch (err) {
            return;
        }
        if (!tripToken) return;

        this.app.ajax({
            url: `${this.app.settings.endpoints}trip/claim/`,
            method: 'POST',
            data: {data: {trip_token: tripToken}},
            callback: response => {
                if (!response || !response.data) return;
                const d = response.data;
                if (d.matched) {
                    this._removeTripToken();
                    return;
                }
                if (!d.claimed) {
                    this._removeTripToken();
                    return;
                }
                // claimed=true, matched=false — show dialog with flight info
                if (d.flight) {
                    this._showTripClaimDialog(d.flight, d.inviter_name);
                }
            },
            error: () => {
                this._removeTripToken();
            }
        });
    }

    _removeTripToken() {
        try { window.localStorage.removeItem('trip_token'); } catch (err) {}
    }

    _showTripClaimDialog(flight, inviterName) {
        const L = this.app.lang || {};
        const depCode = flight.departure_code || '';
        const destCode = flight.destination_code || '';
        const flightNum = flight.flight_num || '';
        const flightDate = flight.flight_date || '';

        const titleTpl = L['trip_invite_title_from'] || '%s invites you to a trip';
        const title = inviterName
            ? titleTpl.replace('%s', inviterName).replace('{}', inviterName)
            : (L['trip_invite_title'] || 'Trip invitation');
        const flightInfo = `${depCode} → ${destCode}, ${flightNum}, ${flightDate}`;
        const hint = L['trip_invite_add_flight_hint'] || 'To join, add this flight to your trips.';
        const btnAdd = L['trip_invite_add_flight'] || 'Add flight';
        const btnLater = L['trip_invite_later'] || 'Later';

        this.app.dialog({
            id: 'trip-claim-dialog',
            name: title,
            content: `
                <div class="text-center" style="padding: 10px 0">
                    <p style="font-size: 16px; margin-bottom: 15px">
                        <b>${flightInfo}</b>
                    </p>
                    <p>${hint}</p>
                    <div style="margin-top: 20px">
                        <button class="btn btn-primary btn-block" data-bind="add-flight">
                            ${btnAdd}
                        </button>
                        <button class="btn btn-default btn-block" data-dismiss="modal" style="margin-top: 8px">
                            ${btnLater}
                        </button>
                    </div>
                </div>
            `,
            buttons: [{
                name: 'add-flight',
                action: () => {
                    this.app.closeModal();
                    this._openPrefillCheckin(flight);
                }
            }]
        });
    }

    _openPrefillCheckin(flight) {
        const threadsView = this.app.getObject('threads/');
        if (!threadsView) {
            this.app.get('threads/');
            return;
        }

        const prefillData = {
            edit_mode: true,
            data: {
                status: 'new',
                is_in_progress: false,
                is_btn_psg_add: true,
                files: [],
                flights: [{
                    airline: {code: flight.airline_code || '', name: flight.airline_code || ''},
                    flight_num: flight.flight_num || '',
                    flight_date: flight.flight_date || '',
                    departure: {code: flight.departure_code || ''},
                    destination: {code: flight.destination_code || ''},
                }],
                passengers: [{}],
            }
        };

        const newUri = this.app.getUriForNewInstanse('threads_new/');
        const newCheckin = this.app.initObject(newUri, 'thread_new', prefillData);
        newCheckin.parent = threadsView;
        threadsView.data.edit_thread = newCheckin;
        newCheckin.get(false, () => {
            threadsView.render();
            newCheckin.edit(true);
        });
    }

    onReceivePush(payload, callback) {
        this.app.dataStorage.clearNotification();
        if (!payload.url) {
            console.log(`Received notification without url ignoring it`);
            return;
        }
        console.log(`Received notification with url ${payload.url}`);
        // replacing thread by single_thread for status pushes,
        // to navigete on single checkin view instead of group
        if (payload.url.match(/^threads\/\d+\/checkins\/\d+\/$/)) {
            payload.url = payload.url.replace('threads/', 'single_thread/');
        };
        this.app.get(
            payload.url,
            null, null, // class and data
            () => callback && callback(true),
            true // force
        )
    }
    get(uri) {
        const user_profile = this.app.settings.user_profile;
        if (!user_profile || !user_profile.id || uri === 'login/') {
            return 'login/';
        };
        if (!user_profile.is_tos_and_privacy_policy_accepted) {
            return 'user/tos_and_privacy_policy/';
        }
        if (!user_profile.is_active) {
            return 'user/verification/';
        }
        if (!user_profile.has_user_seatmap_strategies) {
            return 'user/seat_preferences/';
        }
        if (!uri) {
            return this.app.start_uri;
        }
        return uri;
    }
    showBoardings(checkins_data) {
        const collapsedContainer = document.getElementById(`files-${checkins_data.id}`);
        if (collapsedContainer) {
            toggleClass(collapsedContainer, 'in');
            return true;
        }

        const file = checkins_data.files[0];
        return this.app.platform.showFile(
            file.id, file.fileurl, file.ext, file.content_type,
            checkins_data.id, file.filetype
        );
        return true;
    }
    showFile(id, url, ext, content_type, checkin_id, filetype) {
        const isBoarding = filetype === 'boardingPass';
        if (isBoarding) {
            this.app.dataStorage.isBPUniq(
                checkin_id,
                () => this.sendEvent('boarding_pass_shown', {checkin_id})
            );
        }
        return true;
    }
    showPassengerStats(id) {
        this.app.get('passenger_stats/');
    }
    showRateDialog() {
        console.log('not implemented');
    }
    openPaymentWindow(url, callback, allow_dark = true) {
        const frameURL = `${url}&lang=${this.app.settings.lang}${
            allow_dark ? '&allow_dark=true' : ''
        }&post_close_window=true`;
        this.openPaymentWindowCallback = callback;
        if (!this.bindPostMessage) {
            window.addEventListener('message', event => {
                if (event.data === 'closeWindow') {
                    this.app.closeModal();
                    if (this.openPaymentWindowCallback) this.openPaymentWindowCallback();
                }
            });
            this.bindPostMessage = true;
        }
        this.app.current_view.loading(false);
        this.app.dialog({
            content: `<iframe src="${frameURL}"></iframe>`,
            subclass: 'modal-dialog-payment',
            onClose: () => {
                if (this.openPaymentWindowCallback) this.openPaymentWindowCallback();
            }
        });
    }
    onNavigate(uri) {
        return;
    }
    checkUploadFilesSupport() {
        return true;
    }

    buySubscription(product_id) {
        this.app.closeModal();
        this.app.dialogComponent(
            'user_subscription_buy_modal/',
            'user_subscription_buy_modal',
            {subclass: 'modal-dialog-seatmap-settings'},
            this.app.current_view
        );
    }

    buyCheckins() {
        this.app.get('user/buy_checkins/');
    }

    paymentComplete() {
        const userData = this.app.settings.user_profile;
        const wasFree = userData.is_free;
        const checkinsBallance = userData.billing && userData.billing.checkin_balance;

        this.app.getUserData(data => {
            if (wasFree && !data.is_free) {
                this.app.updateView('user_subscription_banner/');
                this.app.updateView('user/checkins/success/');
                this.app.get('user/checkins/success/');
            }
            if (checkinsBallance < data.billing.checkin_balance) {
                this.app.updateView('user/checkins/success/')
                this.app.get('user/checkins/success/');
            }
        }, null, true);
    }

    sendEvent(eventName, params) {
        console.log('sendEvent ' + eventName);
        if (window.ya) window.ya.reachGoal(eventName, params);
    }

    setBadge() {}

    share(text, element) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        selection.removeAllRanges();
        element.dataset.toggle = 'tooltip';
        element.dataset.title = this.app.lang['copied to buffer'];
        element.style.cssText = '';
        this.app.showToolTip({target: element, stopPropagation: () => {}})
    }

    shareNative(options) {
        if (navigator.share) {
            navigator.share(options).catch(() => {});
        }
    }

    close() {
        console.error('Close method does not implemented for platrofm web');
    }

    changeLang(lang) {
        const has_lang = location.search.match(/lang=\w+/);
        location.href = location.origin + location.pathname
            + ( has_lang
                    ? location.search.replace(/lang=\w+/, `lang=${lang}`)
                    : location.search + `&lang=${lang}`
            );
    }
}
